@if (name === 'cadastre_esterel') {
<div id="solarContactModal" tabindex="-1" aria-labelledby="solarContactModal" aria-modal="true">
    <div class="modal-header">
        <stButton
            class="ms-auto"
            title="Fermer"
            btnClass="p-0"
            (onClick)="activeModal.dismiss('Cross click')"
            iconSvgRight="csgp-esterel-close"
            [iconSvgHeight]="43"
            [iconSvgWidth]="43"
        >
            >
        </stButton>
        <h4 class="modal-title">Contacts</h4>
    </div>

    <div class="modal-body">
        <div>
            <div>Vous êtes un particulier</div>
            <a href="mailto:renovation@esterelcotedazur-agglo.fr" target="_blank"
                >renovation&#64;esterelcotedazur-agglo.fr</a
            >
        </div>

        <div>
            <div>Vous êtes une commune</div>
            <a href="mailto:transitions@esterelcotedazur-agglo.fr" target="_blank"
                >transitions&#64;esterelcotedazur-agglo.fr</a
            >
        </div>

        <div>
            <div>Vous êtes une entreprise</div>
            <a href="mailto:energie@var.cci.fr" target="_blank">energie&#64;var.cci.fr</a>
        </div>
    </div>

    <div class="modal-footer">
        <img
            class="logo-esterel"
            src="../../../../../../../assets/img/login/csgp_esterel/o.svg"
            alt="logo-esterel-o"
            height="100"
        />
    </div>
</div>
} @else if (name === 'cadastre_olc') {
<div id="solarContactModal" tabindex="-1" aria-labelledby="solarContactModal" aria-modal="true">
    <div class="modal-header">
        <h4 class="modal-title">Contacter un expert</h4>
        <stButton
            class="close-modal-olc"
            title="Fermer"
            btnClass="p-0"
            (onClick)="activeModal.dismiss('Cross click')"
            iconSvgRight="csgp-olc-close"
            [iconSvgHeight]="25"
            [iconSvgWidth]="25"
        >
            >
        </stButton>
    </div>
    <hr />
    <div class="modal-body">
        <div [innerHtml]="htmlContact"></div>
    </div>
</div>
} @else if (name === 'cadastre_var') {
<div id="te83ContactModal" tabindex="-1" aria-labelledby="solarContactModal" aria-modal="true">
    <div class="modal-header">
        <h4 class="modal-title">Contacter un expert</h4>
    </div>
    <div class="modal-body">
        <div [outerHTML]="htmlContact"></div>
    </div>
    <div class="modal-footer">
        <stButton btnLabel="Fermer" btnClass="btn-st-default" (click)="close()"></stButton>
    </div>
</div>
} @else if (name === 'cadastre_mayotte') {
<div id="mayotteContactModal" tabindex="-1" aria-labelledby="mayotteContactModal" aria-modal="true">
    <div class="p-2">
        <div class="modalHeader hidden-border-bottom">
            <div class="modal-title">Contacter un expert</div>
        </div>
        <div class="modal-body py-0">
            <p>
                <a
                    href="https://www.electricitedemayotte.com/particulier/conseils-economies-denergie/mes-travaux-de-confort-et-renovation-energetique/trouver-un-professionnel-pres-de-chez-vous/?kg_type_offre=113&kg_commune_offre="
                    target="_blank"
                    >Trouvez un professionnel près de chez vous</a
                >
                pour vous accompagner dans votre projet.
            </p>
            Consultez
            <a
                href="https://electricitedemayotte.com/content/uploads/2025/06/Primes-2025-PartenaireHODARI.pdf"
                target="_blank"
                >la grille des primes</a
            >
            associées aux travaux de confort et de rénovation énergétique
        </div>
        <div class="modal-footer hidden-border-top">
            <stButton
                btnLabel="Fermer"
                class="stbutton"
                btnClass="btn-st-default"
                (click)="close()"
            >
            </stButton>
        </div>
    </div>
</div>
} @else if (name === 'cadastre_scot_hcd') {
<div id="scotHcdContactModal" tabindex="-1" aria-labelledby="scotHcdContactModal" aria-modal="true">
    <div class="modal-header">
        <h4 class="modal-title">Contacts</h4>
    </div>
    <div class="modal-body">
        <div>
            Vous avez des questions ?
            <br />
            Contactez le SCoT Haut Cantal Dordogne :
            <br />
            <a href="mailto:contact@scot-hcd.fr" target="_blank">contact&#64;scot-hcd.fr</a>.
        </div>

        <div>
            Vous êtes localisé dans le Cantal ?
            <br />
            Contactez
            <a
                href="https://www.cantal.fr/lancement-de-cantal-renov-energie-le-service-public-de-renovation-energetique/"
                target="_blank"
            >
                Cantal RéNOV' ENERGiE</a
            >.
            <div class="font-normal">
                Pour les particuliers et professionnels localisés dans le Cantal.
            </div>
        </div>

        <div>
            Besoin d'un accompagnement dans votre projet ?
            <br />
            Trouvez le
            <a
                href="https://france-renov.gouv.fr/annuaires-professionnels/artisan-rge-architecte#/tab"
                target="_blank"
                >professionnel RGE</a
            >
            le plus proche.
        </div>
    </div>
    <div class="modal-footer">
        <stButton btnLabel="Fermer" btnClass="btn-outline-scot contacts" (click)="close()">
        </stButton>
    </div>
</div>
} @else if (name === 'cadastre_sna') {
<div id="sna27ContactModal" tabindex="-1" aria-labelledby="solarContactModal" aria-modal="true">
    <div class="modal-header">
        <h4 class="modal-title">Contacter un expert</h4>
    </div>
    <div class="modal-body">
        <div [outerHTML]="htmlContact"></div>
    </div>
    <div class="modal-footer">
        <stButton btnLabel="Fermer" btnClass="btn-st-default" (click)="close()"></stButton>
    </div>
</div>
} @else {
<div id="solarContactModal" tabindex="-1" aria-labelledby="solarContactModal" aria-modal="true">
    <div class="modal-header">
        <h4 class="modal-title">{{ contactButtonLabel }}</h4>
    </div>
    <div class="modal-body">
        <p>{{ introduction }}</p>
        <div [innerHtml]="htmlContact"></div>
    </div>
    <div class="modal-footer">
        <stButton btnLabel="Fermer" btnClass="btn-st-default" (click)="close()"></stButton>
    </div>
</div>
}
